import * as React from "react"

import { HatTurban } from "./turban"
import { HatBeanie } from "./beanie"

const _Hat = ({ style, color }: { color: string; style: string }) => {
  switch (style) {
    case "beanie":
      return <HatBeanie color={color} />
    case "turban":
      return <HatTurban color={color} />
    case "none":
    default:
      return null
  }
}

export const Hat = React.memo(_Hat)
